import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { businessNetworkMembers, TEXT_FIELDS } from '../../customer-service.service';
import Swal from 'sweetalert2';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';

@Component({
  selector: 'app-contactofbusinessconnections',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent],
  templateUrl: './contactofbusinessconnections.component.html',
  styleUrls: ['./contactofbusinessconnections.component.scss']
})

export class ContactofbusinessconnectionsComponent implements OnInit {

  fields : Array<Partial<TEXT_FIELDS>>;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  businessNetworkId: any;
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    limit: 10,
    page: 1,
    searchContent : null,
    status : null,
    searchAfterKey : null
  }
  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private util : UtilService
  ) {

     this.fields = [
      {label : "Business ID" , key : 'businessNetworkName'},
      {label : "Business Name" , key : "owner"},
      {label : "Business Type" , key : "email"},
      {label : "Network" , key : "role"},
      {label : "Owner" , key : "members"},
      {label : "Role" , key : "members"},
      {label : "Email" , key : "members"},
     ];

     this.columns = [

      {label : 'Members' , key : 'email'},
      {label : 'Email' , key : 'fullName'},
      {label : 'Title' , key : 'userType'},

     ];

     this.businessNetworkDetails = {
       networkName : "Prasnana",
       owner : "pp@gmail.com",
       members : 10
     }



     this._activated_route.parent.data.subscribe(res => {
      this.businessNetworkId = res.networkId;
     });


   }

  ngOnInit(): void {
    if (this.businessNetworkId) {
      this.getBusinessUserNetworkMembers();
    }
  }


  getBusinessUserNetworkMembers() {
    this.API.create('business/findBusinessUsersNetworkMemebers', { businessNetworkId: this.businessNetworkId, ...this.payload }).subscribe(response => {
      if (response.code === AppSettings.SUCESS_CODE) {
        const users = response.data.userDetails;
        const searchKey = response.data.searchAfterKey;

        if (users) {
          const current = users;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(users != null && (users.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }

        this.prevSearchAfterKey =  searchKey;
        const { userData , ...rest } = response.data.network;
        let data = {
          ...rest,
          owner : userData.firstName + " " + userData.lastName,
          members: rest.membersCount,
          userId : userData.userId
        }
        this.businessNetworkDetails = data;
      }
    });
  }

  updateBusinessNetwork(event) {
    this.API.updatePut('business/updateBusinessUsersNetwork', event).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Member Network Updated!',
          text : 'Member Network updated successfully',
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 2000,
        });
        this.businessNetworkDetails = event;
      }else if(res.code=="99998"){
        Swal.fire({
          icon: 'info',
          title: 'Network already exists',
        });
      }
      this.util.stopLoader();
    });
  }


  updateBusinessNetworkMembers(members: any) {
    const userData = members.value;
    let data = {
      businessNetworkId: this.businessNetworkId,
      userId: userData.userId,
      status: userData.connectionStatus
    }
    if(members.checked){
       this.updateMembersbulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick : false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title : "Inactive Member From Network",
        text : `Are you sure you want to inactive ${userData.fullName}?`
      }).then(res=>{

        this.util.startLoader();
        const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.updateMembersbulk(data);
          this.util.stopLoader();
        }
        else{
          updatedData.forEach(res=>{
            if(res.userId === userData.userId){
              res.connectionStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }



      });


    }

  }


  updateMembersbulk(data){
    this.API.create('business/updateBusinessUsersNetworkMemebers', [data]).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Member Updated!',
          text : 'Member updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getBusinessUserNetworkMembers();
        }, 1000);
      }
    });
  }


  onSearch(value , obj : ContactofbusinessconnectionsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onFilter(data , obj : ContactofbusinessconnectionsComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onScroll(obj : ContactofbusinessconnectionsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getBusinessUserNetworkMembers();
    }
  }


}
